import React, { MouseEventHandler, useState } from 'react';
import theme from './ThumbnailGallery.module.scss';
import { classnames, Thumbnail } from '@ygtechnologies/bygr-frontend-component-library';
import { Button, LightBox } from '@ygtechnologies/rubus-ui';
export interface ThumbnailGalleryImage {
    url: string;
    thumbnailUrl?: string;
    title?: string;
    description?: string;
}

export interface ThumbnailGalleryProps {
    images: ThumbnailGalleryImage[];
    className?: string;
    imageClassName?: string;
    useFullSizeImage?: boolean;
    onLightboxToggle?(open: boolean): void;
}

export const ThumbnailGallery = ({
    images,
    className,
    imageClassName,
    useFullSizeImage,
    onLightboxToggle,
}: ThumbnailGalleryProps) => {
    const firstImage = images[0];
    const [lightboxOpenIndex, setLightboxOpenIndex] = useState<number | null>(null);

    if (!firstImage) {
        return null;
    }

    const handleClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
        e.preventDefault();
        toggleLightbox(0);
    };

    const toggleLightbox = (index: number | null) => {
        setLightboxOpenIndex(index);
        onLightboxToggle?.(index !== null);
    };

    return (
        <>
            <a href={firstImage.url} onClick={handleClick} className={classnames(theme.container, className)}>
                <Thumbnail
                    src={useFullSizeImage ? firstImage.url : firstImage.thumbnailUrl}
                    className={classnames(imageClassName, theme.image)}
                />
                {images.length > 1 && (
                    <Button
                        variant="tertiary"
                        className={theme.imageCount}
                        onClick={(e: React.MouseEvent) => {
                            e.preventDefault();
                            e.stopPropagation();
                            toggleLightbox(0);
                        }}>
                        +{images.length - 1}
                    </Button>
                )}
            </a>
            <LightBox
                activeIndex={lightboxOpenIndex}
                setIndex={toggleLightbox}
                images={images.map((x) => ({
                    src: x.url,
                    thumbnailSrc: x.thumbnailUrl ?? '',
                    description: x.description,
                    title: x.title,
                    type: 'image',
                }))}
            />
        </>
    );
};
